import { render, staticRenderFns } from "./MomExperienceAdd.vue?vue&type=template&id=2fdb2716"
import script from "./MomExperienceAdd.vue?vue&type=script&lang=js"
export * from "./MomExperienceAdd.vue?vue&type=script&lang=js"
import style0 from "./MomExperienceAdd.vue?vue&type=style&index=0&id=2fdb2716&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports